import React from 'react';
import { IconProps } from '.';

type ForwardIconProps = {
  color?: string;
} & IconProps;

export const ForwardIcon: React.FC<ForwardIconProps> = ({
  height = 21,
  width = 14,
  color = '#4A4A4A',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 7 12"
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M1 1l4.852 4.852L1 10.705"
      ></path>
    </svg>
  );
};
